import type { GetFamilyPaymentAllocationResponse } from "@/openapi/generated/models";
import { QueryKeys } from "@/lib/types";

export const FAMILY_PAYMENT_ALLOCATION_QUERY_KEY =
  "family-payment-allocation" as const;

export function familyPaymentAllocationQueryKey(
  userId: number,
  billingDateYmd: string,
  currency: string,
) {
  return [
    QueryKeys.Balance,
    FAMILY_PAYMENT_ALLOCATION_QUERY_KEY,
    userId,
    billingDateYmd,
    currency,
  ] as const;
}

export function sumFamilyAllocationTotal(
  rows: GetFamilyPaymentAllocationResponse[] | null | undefined,
): number {
  if (!rows?.length) return 0;
  return rows.reduce((sum, row) => sum + Number(row.totalAmount ?? 0), 0);
}

export function owingFamilyAllocationRows(
  rows: GetFamilyPaymentAllocationResponse[] | null | undefined,
): GetFamilyPaymentAllocationResponse[] {
  if (!rows?.length) return [];
  return rows.filter((row) => Number(row.totalAmount ?? 0) > 0);
}

export function formatFamilyAllocationStudentName(
  row: GetFamilyPaymentAllocationResponse,
): string {
  const name = row.student?.name?.trim();
  if (name) return name;
  const id = row.student?.id;
  return id != null ? `Student #${id}` : "Student";
}
